export const convertNumber = (number: number): string => {
	let convertedNumber: number | string;
	const numberHasDecimals = number % 1 != 0;
	if (!numberHasDecimals) convertedNumber = number;
	if (numberHasDecimals) convertedNumber = number?.toFixed(2).replace(/\./g, ',');
	return convertedNumber?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};
